import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'

const Masterskill = () => {
    const route = all_routes;
    return (
        <>
            {/* Master the skills Five */}
            <section className="master-section-five">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-sm-12" data-aos="fade-down">
                            <div className="section-five-sub">
                                <div className="header-five-title mb-4">
                                    <p>INTERNATIONAL STUDENTS</p>
                                    <h2>Claim Your Ideal Study Program Now!</h2>
                                </div>
                                <div className="career-five-content">
                                    <p data-aos="fade-down">
                                        A decade of refining the fastest, simplest, and highest-quality international study application process—now the world is at your fingertips with just a few clicks.
                                    </p>
                                </div>
                                <div className="d-flex align-items-center">
                                    <Link to={route.register} className="btn btn-primary me-2">
                                        Register Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-sm-6" data-aos="fade-down">
                                    <div className="skill-five-item">
                                        <div className="skill-five-icon bg-success">
                                            <ImageWithBasePath
                                                src="assets/img/icon/skill-03.svg"
                                                alt="Stay motivated"
                                            />
                                        </div>
                                        <div className="skill-five-content">
                                            <h3>Seamlessly Apply to Many Programs at Once!</h3>
                                            <p>
                                               Apply to several programs quickly without the hassle. Maximize your chances of acceptance by submitting multiple applications with just a few clicks. Save time and take control of your future today!
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6" data-aos="fade-down">
                                    <div className="skill-five-item">
                                        <div className="skill-five-icon bg-skyblue">
                                            <ImageWithBasePath
                                                src="assets/img/icon/skill-02.svg"
                                                alt="Stay motivated"
                                            />
                                        </div>
                                        <div className="skill-five-content">
                                            <h3>Find Your Perfect Program from 140,000+ Options Across 5 Top Destinations</h3>
                                            <p>
                                                Choose from thousands of programs in Canada, the US, the UK, Ireland, and Australia. Explore endless opportunities and take the first step toward your global education—fast, easy, and tailored to you.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-sm-6" data-aos="fade-down">
                                    <div className="skill-five-item">
                                        <div className="skill-five-icon bg-danger">                                            
                                            <ImageWithBasePath
                                                src="assets/img/icon/skill-04.svg"
                                                alt="Stay motivated"
                                            />
                                        </div>
                                        <div className="skill-five-content">
                                            <h3>Boost Your Success Rate with Advanced AI and Rigorous Quality Checks</h3>
                                            <p>
                                                Leverage cutting-edge technology and thorough reviews to ensure your application stands out. Increase your chances of acceptance with smart, precise support every step of the way.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* /Master the skills Five */}
        </>

    )
}

export default Masterskill
